import RoomItemRenderInstance from "./roomItemRender.js";
import RoomAvatar from './RoomAvatar.js'
import store from '@/store'
class UpdateHandler {
  constructor() {
    
  }
  updateActiveRoom(new_room_id, old_room_id) {
    if (new_room_id === old_room_id) return;
    const container = document.querySelector('.cpt-room-container');
    if (old_room_id) {
      const oldRoomElBlock = container.querySelector(`[data-room-id="${old_room_id}"] > .shortcut-block`);
      if (oldRoomElBlock) {
        oldRoomElBlock.classList.remove('active');
        const avatar = oldRoomElBlock.querySelector('.cpt-chat-room-avatar');
        if (avatar) {
          avatar.classList.remove('!bg-bd-fl');
        }
      }
    }
    if (new_room_id) {
      const newRoomElBlock = container.querySelector(`[data-room-id="${new_room_id}"] > .shortcut-block`);
      if (newRoomElBlock) {
        newRoomElBlock.classList.add('active');
        const avatar = newRoomElBlock.querySelector('.cpt-chat-room-avatar');
        if (avatar && !avatar.querySelector('.default-img') && !avatar.classList.contains('!bg-bd-fl')) {
          avatar.classList.add('!bg-bd-fl');
        }
      }
    }
    // 更新当前房间头像Gif状态
    RoomItemRenderInstance.updateCurRoomId(new_room_id, old_room_id);
  }
  updateDragRoom(room_id, dragDirection) {
    const container = document.querySelector('.cpt-room-container');
    
    // 1. 清除所有房间项目的拖拽样式（不影响文件夹的拖拽样式）
    const allRoomEls = container.querySelectorAll('.cpt-shortcut-block-wrapper.up, .cpt-shortcut-block-wrapper.down, .cpt-shortcut-block-wrapper.virtual-folder');
    allRoomEls.forEach(el => {
      el.classList.remove('up', 'down', 'virtual-folder');
    });
    
    // 2. 如果有拖拽方向，则给目标房间添加样式
    if (dragDirection) {
      // 先尝试查找文件夹内的房间项
      let dragRoomEl = null;
      
      // 检查所有打开的文件夹
      const openFolders = container.querySelectorAll('.cpt-folder-wrapper.open');
      for (const folder of openFolders) {
        // 在每个打开的文件夹中查找指定的房间项
        const roomInFolder = folder.querySelector(`.folder-room-list [data-room-id="${room_id}"]`);
        if (roomInFolder) {
          // 找到了文件夹内的房间
          dragRoomEl = roomInFolder.closest('.cpt-shortcut-block-wrapper');
          if (dragRoomEl) break;
        }
      }
      
      // 如果文件夹内没找到，尝试在顶层查找
      if (!dragRoomEl) {
        // 查找直接位于容器下的房间项（非文件夹内）
        dragRoomEl = container.querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room_id}"]`);
      }
      
      // 如果找到了目标元素，添加拖拽样式
      if (dragRoomEl) {
        dragRoomEl.classList.add(dragDirection);
      }
    }
  }
  deleteRoom(room_id, folder_id) {
    if (!room_id) return;
    const container = document.querySelector('.cpt-room-container');
    if (folder_id && folder_id != '0') {
      const folderEl = container.querySelector(`.cpt-folder-wrapper[data-folder-id="${folder_id}"]`);
      if (folderEl) {
        const roomEl = folderEl.querySelector(`[data-room-id="${room_id}"]`);
        if (roomEl) {
          roomEl.remove();
        }
      }
    } else {
      const dragRoomEl = container.querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room_id}"]`);
      if (dragRoomEl) {
        dragRoomEl.remove();
      }
    }
  }
  changeFolderOpen(folderId, isOpen, folderInstance, folderData) {
    if (!folderInstance) return;
    // 清除之前的计时器
    if (folderInstance.data._animationTimer) {
      clearTimeout(folderInstance.data._animationTimer);
    }
    if (isOpen) {
      // 打开文件夹：先设置isOpen，确保DOM渲染，但高度为0
      folderInstance.data.isOpen = true;
      folderInstance.data.isAnimationOver = false;
      folderInstance.data.isOpenAnimation = false; // 初始高度为0
      
      // 先更新DOM，渲染出容器但高度为0
      this.updateFolderDisplay(folderId, folderInstance, folderData);
      
      // 使用requestAnimationFrame确保DOM已经渲染，再设置高度动画
      requestAnimationFrame(() => {
        // 强制重绘，确保初始状态被渲染
        const folderEl = document.querySelector(`[data-folder-id="${folderId}"]`);
        if (folderEl) folderEl.offsetHeight; // 触发重绘
        
        // 设置高度动画
        folderInstance.data._animationTimer = setTimeout(() => {
          folderInstance.data.isOpenAnimation = true;
          
          // 更新DOM使高度动画生效
          this.updateFolderDisplay(folderId, folderInstance, folderData);
          
          // 200ms后标记动画完成
          setTimeout(() => {
            folderInstance.data.isAnimationOver = true;
            this.updateFolderDisplay(folderId, folderInstance, folderData);
          }, 200);
        }, 20); // 短暂延迟确保初始状态已渲染
      });
    } else {
      // 关闭文件夹：先设置高度为0，动画结束后再隐藏
      folderInstance.data.isOpenAnimation = false;
      folderInstance.data.isAnimationOver = false;
      
      // 更新DOM先触发高度变化
      this.updateFolderDisplay(folderId, folderInstance, folderData);
      
      // 等待动画完成后再隐藏
      folderInstance.data._animationTimer = setTimeout(() => {
        folderInstance.data.isOpen = false;
        folderInstance.data.isAnimationOver = true;
        
        // 更新DOM隐藏文件夹内容
        this.updateFolderDisplay(folderId, folderInstance, folderData);
      }, 200);
    }
  }
  
  // 更新文件夹DOM显示
  updateFolderDisplay(folderId, folderInstance, folderData) {
    const container = document.querySelector('.cpt-room-container');
    const folderEl = container.querySelector(`[data-folder-id="${folderId}"]`);
    
    if (!folderEl) return;
    
    // 更新文件夹容器类
    if (folderInstance.data.isOpen) {
      folderEl.classList.add('open');
    } else {
      folderEl.classList.remove('open');
    }
    const rooms = folderData?.rooms || [];
    // 获取或创建房间列表容器
    let roomListEl = folderEl.querySelector('.folder-room-list');
    if (!roomListEl && (folderInstance.data.isOpen || !folderInstance.data.isAnimationOver)) {
      // 如果没有房间列表但需要显示，则创建
      roomListEl = document.createElement('div');
      roomListEl.className = 'folder-room-list';
      folderEl.appendChild(roomListEl);
      
      // 渲染房间到列表中
      if (rooms) {
        rooms.forEach(room => {
          const roomHtml = RoomItemRenderInstance.render({
            room,
            folder_id: folderId,
            className: 'folder-inner-room',
            draggable: folderInstance.props.draggable
          });
          roomListEl.insertAdjacentHTML('beforeend', roomHtml);
          // 初始化房间事件
          RoomItemRenderInstance.initEvents({room});
        });
      }
    } else if (roomListEl && !folderInstance.data.isOpen && folderInstance.data.isAnimationOver) {
      // 如果有房间列表但不需要显示，则移除
      roomListEl.remove();
    }
    
    // 更新列表高度
    if (roomListEl) {
      const itemHeight = 54; // 每个房间项的高度
      const height = folderInstance.data.isOpenAnimation ? itemHeight * rooms.length + 4 + 'px' : '0px';
      
      roomListEl.style.height = height;
      roomListEl.style.overflow = folderInstance.data.isAnimationOver && folderInstance.data.isOpen ? 'unset' : 'hidden';
    }

    if (!folderInstance.data.isOpenAnimation && folderInstance.data.isOpen) {
      // 这是收起动画的情况，仍然保持isOpen=true
      // 手动处理缩略图标动画，与高度动画同步
      folderEl.classList.remove('open');
    }

    // 如果是展开 -> 收起的话，重新渲染头像（错误处理）
    if (folderInstance.data.isOpen) {
      this.updateFolderAvatar(folderEl, folderInstance, folderData)
    }
  }
  updateFolderDragDirection(folder_id, dragDirection) {
    const container = document.querySelector('.cpt-room-container');
    const allFolderEls = container.querySelectorAll('.cpt-folder-wrapper.up, .cpt-folder-wrapper.down, .cpt-folder-wrapper.virtual-folder');
    
    allFolderEls.forEach(el => {
      el.classList.remove('up', 'down', 'virtual-folder');
    });
    if (dragDirection) {
      const folderEl = container.querySelector(`[data-folder-id="${folder_id}"]`);
      if (folderEl) {
        folderEl.classList.add(dragDirection);
      }
    }
  }
  updateFolderAvatar(folderEl, folderInstance, folderData) {
    if (!folderEl) return;
    const avatarContainer = folderEl.querySelector('.folder-guild-wrapper .shortcut-block');
    if (avatarContainer) {
      // 创建新的头像HTML
      let newAvatarsHTML = '';
      const maxAvatars = 4; // 最多显示4个头像
      const avatarRooms = folderData.rooms.slice(0, maxAvatars);
      
      // 清除旧头像记录
      if (folderInstance.roomAvatars) {
        folderInstance.roomAvatars.clear();
      }
      
      // 为每个房间创建头像并添加到实例中
      avatarRooms.forEach(room => {
        const avatar = new RoomAvatar({
          room_name: room.room_name,
          img: room.room_avatar,
          only_one_char: true,
          width: 16,
          icon_width: 12,
          webp_quality: 50,
          customAttr: `data-room-id="${room.room_id}"`
        });
        
        folderInstance.roomAvatars.set(room.room_id, avatar);
        newAvatarsHTML += avatar.render();
      });
      
      // 更新DOM并添加渐变动画
      avatarContainer.innerHTML = newAvatarsHTML;
      avatarContainer.style.opacity = '0';
      
      // 使用requestAnimationFrame确保DOM更新后再添加动画
      requestAnimationFrame(() => {
        // 初始化新头像的事件
        avatarRooms.forEach((room, index) => {
          const avatarEl = avatarContainer.querySelector(`.cpt-chat-room-avatar:nth-child(${index + 1})`);
          const avatar = folderInstance.roomAvatars.get(room.room_id);
          avatar && avatarEl && avatar.initEvents(avatarEl);
        });
        
        // 添加过渡动画
        avatarContainer.style.transition = 'opacity 0.3s ease';
        avatarContainer.style.opacity = '1';
      });
    }
  }
  // 更新房间红点、文件夹红点
  updateRedPoint(folderData, folderInstance) {
    const folder_id = folderData.folder_id && folderData.folder_id !== '0' ? folderData.folder_id : null;
    if (folder_id) {
      const folderEl = document.querySelector(`.cpt-folder-wrapper[data-folder-id="${folder_id}"]`);
      if (folderEl) {
        const isOpen = folderEl.classList.contains('open');
        if (isOpen) {
          folderData.rooms.forEach(room => {
            this.updateRoomRedPoint(room.room_id);
            this.updateRoomAudioIcon(room)
          })
        }
        this.updateFolderRedPoint(folderInstance, folderData, folderEl);
      }
    } else {
      folderData.rooms.forEach(room => {
        this.updateRoomRedPoint(room.room_id);
        this.updateRoomAudioIcon(room)
      })
    }
  }
  updateFolderRedPoint(folderInstance, folderData, folderEl) {
    const html = folderInstance.renderRoomStatus();
    const shortcutBlock = folderEl.querySelector('.folder-guid-outer');
    const redPoint = shortcutBlock.querySelector('.cpt-red-num-wrapper') || shortcutBlock.querySelector('.folder-guild .red-point');
    redPoint && redPoint.remove();
    if (shortcutBlock) {
      const iconfont = shortcutBlock.querySelector('.iconfont.folder-speak');
      iconfont && iconfont.remove();
      shortcutBlock.insertAdjacentHTML('beforeend', html);
    }
  }
  updateRoomRedPoint(room_id) {
    const roomEl = document.querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room_id}"]`);
    if (roomEl) {
      const html = RoomItemRenderInstance.renderRedNum({room_id});
      const shortcutBlock = roomEl.querySelector('.shortcut-block');
      const redPoint = shortcutBlock.querySelector('.cpt-red-num-wrapper') || shortcutBlock.querySelector('.red-point');
      redPoint && redPoint.remove();
      if (html && shortcutBlock) {
        shortcutBlock.insertAdjacentHTML('beforeend', html);
      }
    }
  }
  updateRoomAudioIcon (room) {
    RoomItemRenderInstance.updateRoomData(room);
    const roomEl = document.querySelector(`.cpt-shortcut-block-wrapper[data-room-id="${room.room_id}"]`);
    if (roomEl) {
      const iconClass = RoomItemRenderInstance.stateIconClass(room);
      const iconEl = roomEl.querySelector('.iconfont.icon-room-state');
      iconEl && iconEl.remove();
      if (iconClass) {
        const shortcutBlock = roomEl.querySelector('.shortcut-block');
        if (shortcutBlock) {
          const isChannelActive = !store.getters.channel_connecting && store.getters.cur_channel_data.room_id === room.room_id;
          shortcutBlock.insertAdjacentHTML('beforeend', `<i class="iconfont icon-room-state ${iconClass}${isChannelActive ? ' active' : ''}"></i>`);
        }
      }
    }
  }
}
export default new UpdateHandler();